/**
 * JEAN D'ARCEL | Cosmetique — Predictive Search
 * Live search suggestions as user types
 */

(function () {
  'use strict';

  class PredictiveSearch {
    constructor(input) {
      this.input = input;
      this.form = input.closest('form');
      this.resultsContainer = document.querySelector('.search-overlay__results');

      this.debounceTimer = null;
      this.abortController = null;

      if (!this.resultsContainer) return;
      this.init();
    }

    init() {
      this.input.addEventListener('input', () => this.onInput());
      this.input.addEventListener('focus', () => this.onInput());

      document.addEventListener('click', (e) => {
        if (!this.form.contains(e.target)) {
          this.hideResults();
        }
      });

      this.input.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          this.hideResults();
          this.input.blur();
        }
      });
    }

    onInput() {
      const query = this.input.value.trim();

      clearTimeout(this.debounceTimer);

      if (query.length < 2) {
        this.hideResults();
        return;
      }

      this.debounceTimer = setTimeout(() => {
        this.fetchResults(query);
      }, 300);
    }

    async fetchResults(query) {
      if (this.abortController) {
        this.abortController.abort();
      }
      this.abortController = new AbortController();

      try {
        const response = await fetch(
          `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,article,page&resources[limit]=6&resources[options][unavailable_products]=last`,
          { signal: this.abortController.signal }
        );

        if (!response.ok) throw new Error('Search failed');

        const data = await response.json();
        this.renderResults(data.resources.results, query);
      } catch (error) {
        if (error.name !== 'AbortError') {
          console.error('Predictive search error:', error);
        }
      }
    }

    renderResults(results, query) {
      const products = results.products || [];
      const pages = results.pages || [];
      const articles = results.articles || [];

      if (products.length === 0 && pages.length === 0 && articles.length === 0) {
        this.resultsContainer.innerHTML = `
          <div class="predictive-search__empty">
            <p>Nu am găsit rezultate pentru "${this.escapeHtml(query)}"</p>
          </div>
        `;
        this.showResults();
        return;
      }

      let html = '<div class="predictive-search__results">';

      // Products
      if (products.length > 0) {
        html += `
          <div class="predictive-search__group">
            <h3 class="predictive-search__heading">Produse</h3>
            <ul class="predictive-search__list">
        `;
        products.forEach((product) => {
          const imageHtml = product.image
            ? `<img src="${product.image}" alt="${this.escapeHtml(product.title)}" loading="lazy" width="50" height="50">`
            : '';
          html += `
            <li class="predictive-search__item">
              <a href="${product.url}" class="predictive-search__link">
                <div class="predictive-search__image">${imageHtml}</div>
                <div class="predictive-search__info">
                  <span class="predictive-search__title">${this.escapeHtml(product.title)}</span>
                </div>
              </a>
            </li>
          `;
        });
        html += '</ul></div>';
      }

      // Pages
      if (pages.length > 0) {
        html += `
          <div class="predictive-search__group">
            <h3 class="predictive-search__heading">Pagini</h3>
            <ul class="predictive-search__list">
        `;
        pages.forEach((page) => {
          html += `
            <li class="predictive-search__item">
              <a href="${page.url}" class="predictive-search__link predictive-search__link--text">
                <span class="predictive-search__title">${this.escapeHtml(page.title)}</span>
              </a>
            </li>
          `;
        });
        html += '</ul></div>';
      }

      html += `
        <div class="predictive-search__footer">
          <a href="/search?q=${encodeURIComponent(query)}" class="predictive-search__view-all">
            Vezi toate rezultatele pentru "${this.escapeHtml(query)}"
          </a>
        </div>
      `;

      html += '</div>';
      this.resultsContainer.innerHTML = html;
      this.showResults();
    }

    showResults() {
      this.resultsContainer.classList.add('predictive-search--visible');
    }

    hideResults() {
      this.resultsContainer.classList.remove('predictive-search--visible');
    }

    escapeHtml(text) {
      const div = document.createElement('div');
      div.textContent = text;
      return div.innerHTML;
    }
  }

  // Initialize
  document.addEventListener('DOMContentLoaded', () => {
    const searchInput = document.querySelector('.search-overlay__input');
    if (searchInput) {
      new PredictiveSearch(searchInput);
    }
  });

})();
